import { getFeatureFlags } from '../../core/featureFlags';
import type { MediaInitiativeConfig } from '../../core/featureFlags';
import type { Preset } from '../../core/types';

export function imagePolicyInstructions(
  preset: Preset,
  config: MediaInitiativeConfig = getFeatureFlags().imageInitiative,
): string {
  if (!config.enabled) return '';
  const prompt = config.prompts[preset.imageGenerationPolicy ?? 'balanced'];
  return typeof prompt === 'string' ? prompt : '';
}
